<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">C<span class="small">ONTENTS</span></p>
<p class="toc1"><a href="#/Preface">Preface</a></p>
<p class="toc"><a href="#/Introduction">Introduction</a></p>
<p class="toc1"><a href="#/Chapter1#C1">1. La Rivière aux Raisins</a></p>
<p class="toc"><a href="#/Chapter2#C2">2. Legends and Lore</a></p>
<p class="toc"><span href="#/Chapter3#C3" title="Link target outside of Sample">3. Keepers of the Fire</span></p>
<p class="toc"><span href="#/Chapter4#C4" title="Link target outside of Sample">4. The Shooting Star: Tecumseh</span></p>
<p class="toc"><span href="#/Chapter5#C5" title="Link target outside of Sample">5. The Civilians Battle</span></p>
<p class="toc"><span href="#/Chapter6#C6" title="Link target outside of Sample">6. Custer’s Connection</span></p>
<p class="toc"><span href="#/Chapter7#C7" title="Link target outside of Sample">7. Monroe’s Mysterious Cannon</span></p>
<p class="toc"><span href="#/Chapter8#C8" title="Link target outside of Sample">8. Boroughs and Bygone Towns</span></p>
<p class="toc"><span href="#/Chapter9#C9" title="Link target outside of Sample">9. For What Ails You…</span></p>
<p class="toc"><span href="#/Chapter10#C10" title="Link target outside of Sample">10. Monroe’s Sordid Past</span></p>
<p class="toc"><span href="#/Chapter11#C11" title="Link target outside of Sample">11. The Railroad to Freedom</span></p>
<p class="toc"><span href="#/Chapter12#C12" title="Link target outside of Sample">12. Monroe’s Miami Beach</span></p>
<p class="toc"><span href="#/Chapter13#C13" title="Link target outside of Sample">13. Dry Monroe?</span></p>
<p class="toc"><span href="#/Chapter14#C14" title="Link target outside of Sample">14. Forgotten Cities of the Dead</span></p>
<p class="toc"><span href="#/Chapter15#C15" title="Link target outside of Sample">15. To Arms!</span></p>
<p class="toc"><span href="#/Chapter16#C16" title="Link target outside of Sample">16. Monroe Takes Center Stage</span></p>
<p class="toc"><span href="#/Chapter17#C17" title="Link target outside of Sample">17. Tragic Turn of Events</span></p>
<p class="toc1"><span href="#/Notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?40e8c6fe